import api from '../../../api/clinique/_examens'

let examensCache = null
let examensChargesA = 0
let examensEnCours = null

export default {
    getExamens() {
        if (examensCache && Date.now() - examensChargesA < 30000) return Promise.resolve(examensCache)
        if (examensEnCours) return examensEnCours
        examensEnCours = api.getExamens().then(response => {
            examensCache = response
            examensChargesA = Date.now()
            return response
        }).finally(() => { examensEnCours = null })
        return examensEnCours
    },

    getAllExamensForExterne() {
        return new Promise((resolve, reject) => {
            api.getAllExamensForExterne().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getBulletinExamen(data) {
        return new Promise((resolve, reject) => {
            api.getBulletinExamen(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}
